import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import classnames from 'classnames';
import { canUserNotPermission, canUpdateGoogleDriveDeleteLogic } from '../authorizations';

import AnimationMarkerForm from './AnimationMarkerForm';
import AnimationMarkersInPlayer from './AnimationMarkersInPlayer';
import MarkShape from './MarkShape';
import {getStyleOfSize} from "../util/getStyleofSize"
import { styles } from "../util/styleDrawComponent";
import PolyLineSvg from "./PolyLineSvg";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, NavLink } from 'reactstrap';
import { fetchHeightHeader } from '../shared';
import CommentDetail from './CommentDetail';
import GdriveFileDeletedModal from './GdriveFileDeletedModal'
import iconDownload from '../../../assets/images/icon-download-white.svg'
import iconArrowLeft from '../../../assets/images/arrow_left.svg'
import iconArrowRight from '../../../assets/images/arrow_right.svg'
import iconArrowUp from '../../../assets/images/arrow_up.svg'
import iconArrowDown from '../../../assets/images/arrow_down.svg'
import iconPlus from '../../../assets/images/magnifying_glass_icon.png'
import iconMinus from '../../../assets/images/zoom_out_glass_icon.png'
import imgConvertingPdfThumbnail from '/app/assets/images/thumbnail_temp_pdf_black.png';
import { COMMENT_BOX_OPENED_EVENT, createCommentBoxSyncId, announceCommentBoxOpened } from '../util/animation-marker';

const showSVGIndex = 1000;
const hideSVGIndex = -1;

const markersVisibilities = ['all', 'circle', 'none'];

export default class AnimationPdf extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTime: 0,
      isMarking: false,
      startX: 0,
      startY: 0,
      currentX: 0,
      currentY: 0,
      currentWidth: 0,
      currentHeight: 0,
      currentShape: 'point',
      shouldShowForm: false,
      markersVisibility: 'all',
      temp: false,
      changeCss: false,
      canvasWidth: 0,
      canvasHeight: 0,
      zIndexSvg: hideSVGIndex,
      listItemSvg: [],
      currentItemSvg: null,
      settingDraw: {
        color: 'black',
        lineWidth: 3
      },
      canvasPositionImgs: [],
      currentCanvasWidth: 0,
      currentCanvasHeight: 0,
      isShowModalNotCompareVersion: false,
      timestamp: new Date().getTime(),
      loadedPdfPages: [],
      isAllImagesLoaded: false,
      pdfPagesAspectRatio: {},
      pdfPagesOriginalSize: {},
      currentPageIndex: 0, // Track current page index
      goToPage: 1, // State to hold the page number input
      loadingText: null,
      isLoading: false,
      shouldShowGdriveFileDeletedModal: false,
      localZoom: 100, // Local zoom level that resets on page change
    };
    this.pdfContainerRef = React.createRef();
    this.currentImageRef = React.createRef();
    this.goToPageRef = React.createRef();
    this.commentBoxSyncId = createCommentBoxSyncId('animation-pdf');
  }

  componentWillUnmount() {
    document.removeEventListener('tm-modal-back-click', this.handleModalBackClick);
    document.removeEventListener(COMMENT_BOX_OPENED_EVENT, this.handleCommentBoxOpened);
    // ❷ ホイール・タッチイベント解除
    var wcEl = this.getWrapCenter();
    if(wcEl){
      if(this._onWheelPdf)      wcEl.removeEventListener('wheel',      this._onWheelPdf);
      if(this._onTouchStartPdf) wcEl.removeEventListener('touchstart', this._onTouchStartPdf);
      if(this._onTouchEndPdf)   wcEl.removeEventListener('touchend',   this._onTouchEndPdf);
    }
  }

  handleModalBackClick = (e) => {
    if (!this.props.isOpen) return;

    if (typeof this.closeModal === 'function') {
      this.closeModal();
    } else if (this.props.onClickClose) {
      this.props.onClickClose();
    } else if (this.props.toggle) {
      this.props.toggle();
    }
  };

  // [2026-06-29] 2画面比較で自分の画面のwrap-centerを取る（getElementByIdは左画面しか取れずスクロール不能になるため）
  getWrapCenter = () => {
    const root = findDOMNode(this);
    if (root && root.querySelector) {
      const el = root.querySelector('#wrap-center');
      if (el) return el;
    }
    return document.getElementById('wrap-center');
  }

  componentDidMount() {
    document.addEventListener('tm-modal-back-click', this.handleModalBackClick);
    document.addEventListener(COMMENT_BOX_OPENED_EVENT, this.handleCommentBoxOpened);

    this.reset();
    const { currentAnimation, scaleImage } = this.props;

    // Initialize localZoom with scaleImage from props
    if (scaleImage && scaleImage !== this.state.localZoom) {
      this.setState({ localZoom: scaleImage });
    }

    if (currentAnimation.animation_pdf_pages && currentAnimation.animation_pdf_pages.length > 0) {
      setTimeout(() => {
        this.preloadCurrentPage();
      }, 100);
    }
    const canOpenModal = currentAnimation?.additional_info?.gdrive_pdf ||( currentAnimation?.additional_info?.gdrive_file && currentAnimation?.additional_info?.gdrive_image == undefined)
    if(canOpenModal && canUpdateGoogleDriveDeleteLogic(this.props.role)) {
      const event = new CustomEvent('gdriveFileDeletedModalLoaded', {'detail': currentAnimation?.additional_info?.handle_delete});
      document.dispatchEvent(event);
    } else {
      const event = new CustomEvent('gdriveFileDeletedModalUnLoaded');
      document.dispatchEvent(event);
    }

    // ❷ 閲覧モード時のホイールスクロールによるページ移動（PC用）
    var _wheelLock = false;
    this._onWheelPdf = (e) => {
      if(this.props.isCommentMode) return;
      if(_wheelLock) return;
      var el = this.getWrapCenter();
      if(!el) return;
      var atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 0;
      var atTop    = el.scrollTop <= 0;
      if(e.deltaY > 0 && atBottom){
        e.preventDefault();
        _wheelLock = true;
        this.goToNextPage();
        setTimeout(function(){ _wheelLock = false; }, 1800);
      } else if(e.deltaY < 0 && atTop){
        e.preventDefault();
        _wheelLock = true;
        this.goToPreviousPage();
        setTimeout(function(){ _wheelLock = false; }, 1800);
      }
    };
    // ❷ iPad/タッチデバイス用スワイプページ移動
    var _touchStartY = null;
    this._onTouchStartPdf = (e) => {
      if(this.props.isCommentMode) return;
      _touchStartY = e.touches[0].clientY;
    };
    this._onTouchEndPdf = (e) => {
      if(this.props.isCommentMode) return;
      if(_touchStartY === null) return;
      var deltaY = _touchStartY - e.changedTouches[0].clientY;
      var el = this.getWrapCenter();
      if(!el){ _touchStartY = null; return; }
      var atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 0;
      var atTop    = el.scrollTop <= 0;
      // 50px以上のスワイプのみ反応
      if(deltaY > 50 && atBottom){
        this.goToNextPage();
      } else if(deltaY < -50 && atTop){
        this.goToPreviousPage();
      }
      _touchStartY = null;
    };
    var wcEl = this.getWrapCenter();
    if(wcEl){
      wcEl.addEventListener('wheel',      this._onWheelPdf,      { passive: false });
      wcEl.addEventListener('touchstart', this._onTouchStartPdf, { passive: true });
      wcEl.addEventListener('touchend',   this._onTouchEndPdf,   { passive: true });
    }
  }

  preloadCurrentPage = () => {
    const { currentAnimation } = this.props;
    const { currentPageIndex } = this.state;
    
    if (currentAnimation && currentAnimation.animation_pdf_pages && 
        currentAnimation.animation_pdf_pages.length > currentPageIndex) {
      const img = new Image();
      const page = currentAnimation.animation_pdf_pages[currentPageIndex];
      /* FIX 20260814-pdfcors iPadでPDFのコピー直後やリロード直後に、版・ページを移動すると
         メディアが表示されずエラー画像のままになる不具合を是正する。同じ画像を、この先読みは
         crossOrigin なしで、画面表示側(1365行・1390行)は crossOrigin="anonymous" 付きで
         取りに行っており、URLは全く同じであった。iPad(WebKit)は先読みで取っておいた
         crossOrigin なしの分を、後から来た crossOrigin あり の要求にも使い回すため、
         条件が一致せず拒否され失敗する。PCで再現しないのは別物として扱うためであり、
         時間を置くと直るのは取っておいた分が消えるためである。実機で、失敗しているURLを
         Safariのアドレス欄へ直接入力すると画像が正常に表示されることを確認済みで、
         S3・URLともに正常であることを確定させた。先読み側にも同じ crossOrigin を付けて
         条件を揃える。取りに行く先・回数・タイミングは変えておらず、画面表示側・ペンツールの
         canvas描画・サーバー側・DBはいずれも未変更で、通信は1件も増えていない。
         8/12の 20260811-pdfretry(失敗時に1回だけ取り直す)は、Reactが再描画のたびにURLを
         元へ戻すため効いていないことを実機の記録で確認済みだが、無害なため残している。 */
      img.crossOrigin = "anonymous";
      img.src = `${page.file_object.url}?v=${this.state.timestamp}`;
      img.onload = () => {
        this.onPdfPageLoad({ target: img }, currentPageIndex);
        $('.preloader').fadeOut();
      };
    }
  }

  onImageLoad = () => {
    $('.preloader').fadeOut();
  }

  handleCommentBoxOpened = (event) => {
    if (event.detail?.sourceId === this.commentBoxSyncId) return;

    this.setState({
      shouldShowForm: false,
      isMarking: false,
    });
  }

  openMarkerForm = (nextState = {}, callback) => {
    this.props.updateSelectedMarker(null);
    announceCommentBoxOpened(this.commentBoxSyncId);
    this.setState({
      shouldShowForm: true,
      isMarking: false,
      ...nextState,
    }, callback);
  }

  onPdfPageLoad = (event, index) => {
    const { pdfPagesAspectRatio, pdfPagesOriginalSize } = this.state;
    const { currentAnimation } = this.props;
    
    const img = event.target;
    const pdfPage = currentAnimation.animation_pdf_pages[index];
    
    // Save aspect ratio and original size of the page
    const updatedPdfPagesAspectRatio = { ...pdfPagesAspectRatio };
    const updatedPdfPagesOriginalSize = { ...pdfPagesOriginalSize };
    
    if (img.naturalWidth && img.naturalHeight) {
      updatedPdfPagesAspectRatio[pdfPage.id] = img.naturalWidth / img.naturalHeight;
      updatedPdfPagesOriginalSize[pdfPage.id] = {
        width: img.naturalWidth,
        height: img.naturalHeight
      };
    }
    $('.preloader').fadeOut();

    // Use setTimeout to ensure image is fully rendered in DOM
    setTimeout(() => {
      const actualImage = this.currentImageRef.current;
      const container = this.pdfContainerRef.current;

      if (actualImage && container) {
        // Get the ACTUAL rendered size of the image in the DOM
        const rect = actualImage.getBoundingClientRect();
        const canvasWidth = rect.width || actualImage.offsetWidth || container.offsetWidth;
        const canvasHeight = rect.height || actualImage.offsetHeight || container.offsetHeight;

        this.setState({
          canvasHeight: canvasHeight,
          canvasWidth: canvasWidth,
          currentCanvasWidth: canvasWidth,
          currentCanvasHeight: canvasHeight,
          pdfPagesAspectRatio: updatedPdfPagesAspectRatio,
          pdfPagesOriginalSize: updatedPdfPagesOriginalSize
        }, () => {
          // Update canvas context after state is set
          if (this.canvas) {
            this.ctx = this.canvas.getContext('2d');
            this.updateCanvasForCurrentPage();
          }
          setTimeout(() => {
            this.setState({ isPdfPageLoaded: true });
          }, 200);
        });

        if (this.props.getHeightAnimaiton) {
          this.props.getHeightAnimaiton(canvasHeight);
        }
      }
    }, 100);
  }

  syncCanvasWithImage = () => {
    const actualImage = this.currentImageRef.current;
    if (!actualImage) return;

    const rect = actualImage.getBoundingClientRect();
    const width = rect.width || actualImage.offsetWidth || 0;
    const height = rect.height || actualImage.offsetHeight || 0;

    this.setState({
      canvasWidth: width,
      canvasHeight: height,
      currentCanvasWidth: width,
      currentCanvasHeight: height,
      listItemSvg: []
    }, () => {
      this.updateCanvasForCurrentPage();
    });
  }

  componentWillMount() {
    Shared.loadingIndicator()
  }

  update = () => {
    // Get actual rendered size from the current image element
    const actualImage = this.currentImageRef.current;
    if (!actualImage) return;

    const rect = actualImage.getBoundingClientRect();
    const width = rect.width || actualImage.offsetWidth || 0;
    const height = rect.height || actualImage.offsetHeight || 0;

    // Update if either width OR height changed (not just width)
    if (width !== this.state.canvasWidth || height !== this.state.canvasHeight) {
      this.setState({
        canvasWidth: width,
        canvasHeight: height,
        currentCanvasWidth: width,
        currentCanvasHeight: height,
        listItemSvg: []
      }, () => {
        if (!this.canvas) return;
        this.ctx = this.canvas.getContext("2d");
        this.ctx.clearRect(0, 0, this.state.canvasWidth, this.state.canvasHeight);
        this.updateCanvasForCurrentPage();
      });
    }
  }

  // Method to update canvas with current page image
  updateCanvasForCurrentPage = () => {
    if (!this.canvas || !this.ctx) return;
    
    const { currentAnimation } = this.props;
    const { currentPageIndex } = this.state;
    
    if (currentAnimation && 
        currentAnimation.animation_pdf_pages && 
        currentAnimation.animation_pdf_pages.length > currentPageIndex) {
      
      const currentImage = this.currentImageRef.current;
      if (currentImage && currentImage.complete) {
        this.ctx.drawImage(
          currentImage,
          0,
          0,
          this.state.canvasWidth,
          this.state.canvasHeight
        );
      }
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      settingDraw: newProps.settingDraw,
    });

    // Sync localZoom with scaleImage from props if it changes externally
    if (newProps.scaleImage !== this.props.scaleImage) {
      this.setState({
        localZoom: newProps.scaleImage
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.changeCss != this.props.changeCss) {
      this.setState({
        changeCss: this.props.changeCss
      });
    }

    if (!!this.props.isSelectedMarkerId) {
      this.goToPageWithMarker();
    }

    // Check if scale image has changed
    if (prevProps.scaleImage !== this.props.scaleImage) {
      // Update canvasWidth based on new scale
      setTimeout(() => {
        this.update();
      }, 120);
    }

    // Check if page index has changed
    if (prevState.currentPageIndex !== this.state.currentPageIndex) {
      // Clear canvas and SVG when changing pages
      this.setState({ timestamp: new Date().getTime() });
      this.reset();
      this.preloadCurrentPage();
      // ページ遷移後、新ページ上端から表示するためスクロール位置リセット
      var el = this.getWrapCenter();
      if(el) el.scrollTop = 0;
      // iOS 慣性スクロール対策で次フレームでも再リセット
      requestAnimationFrame(function(){
        if(el) el.scrollTop = 0;
      });
      setTimeout(() => {
        if(el) el.scrollTop = 0;
        this.removeHeightAnimationPreview();
      }, 800);
    }
  }

  // Navigation methods
  goToNextPage = () => {
    const { currentAnimation } = this.props;
    const { currentPageIndex } = this.state;

    if (currentAnimation && currentAnimation.animation_pdf_pages &&
        currentPageIndex < currentAnimation.animation_pdf_pages.length - 1) {
      const newCurrentPageIndex = currentPageIndex + 1;
      this.toggleHeightAnimationPreview();
      this.setState({
        currentPageIndex: newCurrentPageIndex,
        goToPage: newCurrentPageIndex + 1,
        listItemSvg: [] // Clear drawn items when changing pages
      });
    }
  }

  goToPreviousPage = () => {
    const { currentPageIndex } = this.state;
    if (currentPageIndex > 0) {
      const newCurrentPageIndex = currentPageIndex - 1;
      this.toggleHeightAnimationPreview();
      this.setState({
        currentPageIndex: newCurrentPageIndex,
        goToPage: newCurrentPageIndex + 1,
        listItemSvg: [] // Clear drawn items when changing pages
      });
    }
  }

  toggleHeightAnimationPreview = async () => {
    const pdfControlPanel = document.getElementsByClassName('pdf-vertical-control-panel')[0]
    const height = pdfControlPanel.offsetHeight;
    pdfControlPanel.style.height = `${height}px`;
  }

  removeHeightAnimationPreview = () => {
    const pdfControlPanel = document.getElementsByClassName('pdf-vertical-control-panel')[0]
    pdfControlPanel.style.height = 'auto';
  }

  mouseRelativeXY(event) {
    if (this.currentImageRef.current) {
      const page = this.currentImageRef.current;
      const rect = page.getBoundingClientRect();
      
      return [
        (event.clientX - rect.left) / rect.width * 10000,
        (event.clientY - rect.top) / rect.height * 10000
      ];
    }
    
    return this.relativeXY(event.clientX, event.clientY);
  }

  mouseRelativeXYDraw(event) {
    if (this.currentImageRef.current) {
      const page = this.currentImageRef.current;
      const rect = page.getBoundingClientRect();
      
      return [
        (event.nativeEvent.clientX - rect.left) / rect.width * 10000,
        (event.nativeEvent.clientY - rect.top) / rect.height * 10000
      ];
    }
    
    return this.relativeXY(event.nativeEvent.clientX, event.nativeEvent.clientY);
  }

  touchRelativeXY(event) {
    if (this.currentImageRef.current) {
      const page = this.currentImageRef.current;
      const rect = page.getBoundingClientRect();
      
      return [
        (event.touches[0].clientX - rect.left) / rect.width * 10000,
        (event.touches[0].clientY - rect.top) / rect.height * 10000
      ];
    }
    
    return this.relativeXY(event.touches[0].clientX, event.touches[0].clientY);
  }

  relativeXY(eventX, eventY) {
    let playerRect;
    if (this.currentImageRef.current) {
      playerRect = this.currentImageRef.current.getBoundingClientRect();
    } else {
      playerRect = findDOMNode(this.image).getBoundingClientRect();
    }
    
    return [
      (eventX - playerRect.left) / playerRect.width * 10000,
      (eventY - playerRect.top) / playerRect.height * 10000,
    ];
  }

  startMark = ({ x, y }) => {
    if (!this.props.isCommentMode) return;
    // Verify canvas size matches image before marking
    const actualImage = this.currentImageRef.current;
    if (actualImage) {
      const rect = actualImage.getBoundingClientRect();
      const width = rect.width || actualImage.offsetWidth;
      const height = rect.height || actualImage.offsetHeight;

      // If canvas size doesn't match, sync it
      if (Math.abs(width - this.state.canvasWidth) > 1 || 
          Math.abs(height - this.state.canvasHeight) > 1) {
        this.syncCanvasWithImage();
      }
    }

    this.setState({
      isMarking: true,
      shouldShowForm: false,
      startX: x,
      startY: y,
      currentX: x,
      currentY: y,
      currentWidth: 0,
      currentHeight: 0,
      currentShape: 'point'
    });
  }
  moveMark = ({ x, y }) => {
    const { isMarking, startX, startY } = this.state;
    if (!isMarking) return;
    const { max, abs } = Math;
    const distance = max(abs(x - startX), abs(y - startY));
    distance > 10 && startX < x && startY < y
      ? this.setState({
        currentWidth: max(x - startX, 0),
        currentHeight: max(y - startY, 0),
        currentShape: 'rect',
      })
      : this.setState({
        currentWidth: 0,
        currentHeight: 0,
        currentShape: 'point',
      })
  }
  // ダブルクリック判定用
  _lastTapTime = 0;
  _DOUBLE_TAP_MS = 300;

  _showTapHint = () => {
    let toast = document.getElementById('tm-mode-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'tm-mode-toast';
      toast.style.cssText = [
        'position:fixed', 'top:0', 'left:0',
        'transform:translate(-50%,-50%)',
        'background:rgba(0,0,0,0.75)', 'color:#fff',
        'padding:10px 18px', 'border-radius:8px',
        'font-size:13px', 'pointer-events:none',
        'z-index:2147483647', 'white-space:nowrap',
        'opacity:0', 'transition:opacity 0.2s'
      ].join(';');
      document.body.appendChild(toast);
    }
    toast.textContent = 'ダブルクリックするとコメントモードに切り替わります';
    const _getMediaRect = () => {
      try {
        const root = findDOMNode(this);
        const el = root ? root.querySelector('.wrap-animation-preview') || root : null;
        return el ? el.getBoundingClientRect() : null;
      } catch(e) { return null; }
    };
    const rect = _getMediaRect();
    if (rect) {
      toast.style.top = (rect.top + rect.height / 2) + 'px';
      toast.style.left = (rect.left + rect.width / 2) + 'px';
    } else {
      toast.style.top = '50%';
      toast.style.left = '50%';
    }
    toast.style.opacity = '1';
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(() => { toast.style.opacity = '0'; }, 1000);
  };

  _showModeToast = (text) => {
    let toast = document.getElementById('tm-mode-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'tm-mode-toast';
      toast.style.cssText = [
        'position:fixed', 'top:0', 'left:0',
        'transform:translate(-50%,-50%)',
        'background:rgba(0,0,0,0.75)', 'color:#fff',
        'padding:10px 18px', 'border-radius:8px',
        'font-size:13px', 'pointer-events:none',
        'z-index:2147483647', 'white-space:nowrap',
        'opacity:0', 'transition:opacity 0.2s'
      ].join(';');
      document.body.appendChild(toast);
    }
    toast.textContent = text;
    const _getMediaRect = () => {
      try {
        const root = findDOMNode(this);
        const el = root ? root.querySelector('.wrap-animation-preview') || root : null;
        return el ? el.getBoundingClientRect() : null;
      } catch(e) { return null; }
    };
    const rect = _getMediaRect();
    if (rect) {
      toast.style.top = (rect.top + rect.height / 2) + 'px';
      toast.style.left = (rect.left + rect.width / 2) + 'px';
    } else {
      toast.style.top = '50%';
      toast.style.left = '50%';
    }
    toast.style.opacity = '1';
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(() => { toast.style.opacity = '0'; }, 1000);
  };

  _showCommentMode = () => {
    this._justEnteredCommentMode = true;
    setTimeout(() => { this._justEnteredCommentMode = false; }, 300);
    if (this.props.onEnterCommentMode) this.props.onEnterCommentMode();
  };

  endMark = (event) => {
    if (!this.props.isCommentMode) return;
    if (this._justEnteredCommentMode) {
      this._justEnteredCommentMode = false;
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    const { currentAnimationId, animationSelectCurrent, toggleShowModalInputInfoOfNotLogin, isInputInfoMationOfNotLogin } = this.props;
    if (currentAnimationId === animationSelectCurrent) {
      if (gon.is_login || isInputInfoMationOfNotLogin) {
        this.openMarkerForm();
      } else {
        this.setState({ isMarking: false }, () => {
          toggleShowModalInputInfoOfNotLogin();
        });
      }
      this.disableMmount();
    }
  }
  disableMmount(e = '') {
    var menus = document.querySelectorAll('.show-mark-shape');
    menus = [].slice.call(menus);
    menus.forEach(function (element) {
      element.style.pointerEvents = e;
    });
  }
  onSubmitMarkerForm = (body, files, editorSetting) => {
    const { onSubmitMarkerForm } = this.props;
    const { currentX: x, currentY: y, currentWidth: width, currentHeight: height, currentShape: shape, currentTime: time, currentPageIndex } = this.state;
    const { currentAnimation } = this.props;
    
    // Get animation_pdf_page_id from current PDF page
    let animationPdfPageId = null;
    if (currentAnimation && currentAnimation.animation_pdf_pages && 
        currentAnimation.animation_pdf_pages.length > currentPageIndex) {
      animationPdfPageId = currentAnimation.animation_pdf_pages[currentPageIndex].id;
    }
    
    return onSubmitMarkerForm({ 
      body, 
      x, 
      y, 
      width, 
      height, 
      shape, 
      time, 
      files, 
      editorSetting, 
      animationPdfPageId 
    }).then(() => 
      this.setState({ shouldShowForm: false })
    );
  }
  onCloseMarkerForm = () => {
    this.setState({
      shouldShowForm: false,
    }, () => {
      if (this.canvas) {
        this.ctx = this.canvas.getContext("2d");
        this.ctx.clearRect(0, 0, this.state.canvasWidth, this.state.canvasHeight);

        if (this.img) {
          this.ctx.drawImage(
            this.img,
            0,
            0,
            this.state.canvasWidth,
            this.state.canvasHeight
          );
        }
      }
    })
  }

  // [2026-06-29] ❹ ペン切替時に残るテキストの仮マーカーを片付ける（reset丸ごとは呼ばない=副作用なし）
  clearTempMarker() {
    this.setState({
      isMarking: false,
      shouldShowForm: false,
      currentX: 0, currentY: 0,
      currentWidth: 0, currentHeight: 0,
      currentShape: 'point',
      startX: 0, startY: 0,
    });
  }

  draw(e) {
    this.setState({
      isDel: false,
      shouldShowForm: false,
    });

    setTimeout(() => {
      if (this.canvas) {
        const canvas = this.canvas;
        const context = canvas.getContext("2d");
        if (this.currentImageRef.current) {
          context.drawImage(
            this.currentImageRef.current,
            0,
            0,
            this.state.currentCanvasWidth,
            this.state.currentCanvasHeight
          );
        }

        this.setState({
          zIndexSvg: showSVGIndex,
        });
      }
    }, 50);
  }

  eraser() {
    this.setState({
      isDel: true,
    });
  }

  capture(e) {
    const fileDrawName = `draw-image-${moment.now()}`;
    const files = [];
    
    if (this.svg) {
      var svgURL = new XMLSerializer().serializeToString(this.svg);
      const canvas = this.canvas;
      if (canvas) {
        const context = canvas.getContext("2d");
        var img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          context.drawImage(
            img,
            0,
            0,
            this.state.canvasWidth,
            this.state.canvasHeight
          );
          var imageSrc = this.canvas.toDataURL();
          const { listItemSvg} = this.state;
          if (listItemSvg.length === 0) {
            return;
          } else {
           const {listItemSvg} = this.state
           const target = this.state.currentItemSvg || listItemSvg[0]
           const arr = target.capturePoint.split(",")
           const convertArr = arr[1].trim().split(' ')
           const markPointCaptureY = Number(convertArr[0])
           const markPointCaptureX = Number(convertArr[1])
           this.setState({
             currentX: markPointCaptureX,
             currentY: markPointCaptureY
           })
          }
          this.urltoFile(imageSrc, fileDrawName, "image/png").then((file) => {
            files.push(file);
            this.openMarkerForm(
              {
                currentShape: "draw",
                currentTime: 0,
              },
              () => {
                this.makerForm.onFileChange(null, files);
              }
            );
          });
        };
        img.src = "data:image/svg+xml; charset=utf8, " + encodeURIComponent(svgURL);
      }
    }
  }

  urltoFile(url, filename, mimeType) {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  }

  deleteAllDraw() {
    this.setState({
      isDel: false,
      listItemSvg: [],
      shouldShowForm: false,
      zIndexSvg: hideSVGIndex,
    });
  }

  reset(isDelete) {
    if(!isDelete) {
      this.setState({
        isDraw: false,
        isDel: false,
        zIndexSvg: hideSVGIndex,
        listItemSvg: [],
        shouldShowForm: false,
      });
    } else {
      this.setState({
        isDraw: false,
        isDel: false,
        shouldShowForm: false,
      });
    }

    if (this.canvas) {
      this.ctx = this.canvas.getContext("2d");
      this.ctx.fillStyle = "transparent";
      this.ctx.clearRect(0, 0, this.state.canvasWidth, this.state.canvasHeight);
      
      // For PDF pages, draw the current page
      if (this.currentImageRef.current && this.currentImageRef.current.complete) {
        this.ctx.drawImage(
          this.currentImageRef.current,
          0,
          0,
          this.state.canvasWidth,
          this.state.canvasHeight
        );
      }
    }
    // [2026-06-29] PDF: 保存後もペンモード維持。前面化のみ（大きさは触らない=撮影と競合させない）
    if (this.props.isShowDrawComponent) {
      setTimeout(() => {
        this.setState({ zIndexSvg: showSVGIndex });
      }, 50);
    }
  }

  disableScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    window.onscroll = function() {
      window.scrollTo(scrollLeft, scrollTop);
    };
  }

  enableScroll() {
    window.onscroll = function() {};
  }

  onMouseDown(event, isMobile) {
    const { mobile } = this.props;
    if (!this.props.changeCss || this.props.isShowDrawComponent) {
      if (mobile || platform.product === "iPad") {
        document.getElementById("animation-preview").style["overflow"] ="hidden";
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
      if (!this.state.isDraw && !this.state.isDel) {
        this.setState({
          isDraw: true,
        });
        var newItem = {
          id: Date.now(),
          points: "",
          color: this.state.settingDraw.color,
          lineWidth: this.state.settingDraw.lineWidth,
          capturePoint: ""
        };
        if (!isMobile){
          var [x, y] = this.mouseRelativeXYDraw(event);
          newItem.capturePoint = ` , ${y} ${x}`
        } else {
          var [x, y] = this.touchRelativeXY(event);
          newItem.capturePoint = ` , ${y} ${x}`
          this.disableScroll();
        }
        this.setState({
          listItemSvg: [...this.state.listItemSvg, newItem],
          currentItemSvg: newItem,
        });
      }
    }
  }

  onMouseMove = (event, isMobile) => {
    const { currentPageIndex } = this.state;
    const pageElement = document.getElementById(`pdf-page-${currentPageIndex}`);
    if ((!this.props.changeCss || this.props.isShowDrawComponent) && !!pageElement) {
      if (this.state.isDraw) {
        let heightTopToAnimation = fetchHeightHeader();
        var item = document.getElementById(this.state.currentItemSvg.id);
        var points = item.getAttribute("points");
        var capturePoint = item.getAttribute("capturePoint");
        if (!isMobile) {
          let pointsX = event.nativeEvent.layerX;
          let pointsy = event.nativeEvent.layerY
          pointsX = (pointsX * this.state.currentCanvasWidth / pageElement.offsetWidth).toFixed()
          pointsy = (pointsy *  this.state.currentCanvasHeight / pageElement.offsetHeight).toFixed()
          points += ` ${pointsX}, ${pointsy}`;
          var [x, y] = this.mouseRelativeXYDraw(event);
          capturePoint += ` ${x}, ${y}`;
        } else {
          var [x, y] = this.touchRelativeXY(event);
          capturePoint += ` ${x}, ${y}`;
          var _pdfRect = (this.currentImageRef.current || findDOMNode(this.image)).getBoundingClientRect();
          var _pointsX = ((event.touches[0].clientX - _pdfRect.left) / _pdfRect.width * this.state.currentCanvasWidth).toFixed();
          var _pointsY = ((event.touches[0].clientY - _pdfRect.top) / _pdfRect.height * this.state.currentCanvasHeight).toFixed();
          points += ` ${_pointsX}, ${_pointsY}`;
        }
        let itemInList = this.state.listItemSvg.find(
          (obj) => obj.id === this.state.currentItemSvg.id
        );
        if (itemInList) {
          itemInList.points = points;
          itemInList.capturePoint = capturePoint;
        }
        item.setAttribute("points", points);
        item.setAttribute("capturePoint", capturePoint);
      }
    }
  };

  onMouseUp() {
    document.body.style.overflow = "auto";
    if (this.props.changeCss) {
      document.getElementById("animation-preview").style["overflow"] ="auto";
    }
    if (this.state.isDraw) {
      this.setState({
        isDraw: false,
      });
      this.enableScroll();
    }
  }

  onItemMouseOver(event) {
    const { mobile } = this.props;
    const polyWidht = event.target.getBBox().width;
    const polyHeight = event.target.getBBox().height;
    if (mobile ){
      return
    } else if (platform.product === 'iPad'){
      return
    } else {
      if (!this.state.isDraw && this.state.isDel) {
        event.target.setAttribute("stroke-dasharray", "5 5");
        if (polyWidht <= 35 && polyHeight <= 35) {
          let id = event.target.getAttribute("id");
          let newLists = this.state.listItemSvg.filter((obj) => obj.id != id);
          this.setState({
            listItemSvg: newLists,
          });
        }
      }
    }
  }

  onItemMouseLeave(event) {
    if (!this.state.isDraw && this.state.isDel) {
      event.target.setAttribute("stroke-dasharray", "");
    }
  }

  onDelete(event) {
    if (!this.state.isDraw && this.state.isDel) {
      let id = event.target.getAttribute("id");
      let newLists = this.state.listItemSvg.filter((obj) => obj.id != id);
      this.setState({
        listItemSvg: newLists,
      });
    }
  }
  setOption = () => {
    const { currentAnimationId, animationSelectCurrent } = this.props;
    if (currentAnimationId !== animationSelectCurrent) {
      this.fetchCurrentAnimation()
    }
  }

  handleOutsideClick = (e) => {
    if (!this.nodeModalVersion.contains(e.target)) {
      this.setOption();
    }
  };

  fetchCurrentAnimation = () => {
    const { setCurrentAnimation } = this.props;
    this.setState({ isShowModalNotCompareVersion: false }, () => setCurrentAnimation())
  }

  scrollImage = (image, {x, y}) => {
    const { isMarking, startX, startY } = this.state;
    const { max, abs } = Math;
    if (startY >= y || y - startY <= 100 || !isMarking ) return
    
    let playerRect;
    
    if (this.pdfContainerRef && this.pdfContainerRef.current) {
      playerRect = this.pdfContainerRef.current.getBoundingClientRect();
    } else {
      playerRect = findDOMNode(image).getBoundingClientRect();
    }

    /* FIX 20260831-autoscroll 範囲指定の自動スクロール。
       (1)★PDFは setTimeout に渡した通常関数の中で this.getWrapCenter() を呼んでおり、
          通常関数では this が失われるため、呼ばれた瞬間に必ず落ちて一度も動いていなかった。
          画像側は document.getElementById を使うため this を使わず、正常に動いていた。
       (2)★「重い」の正体。debounceTimer が関数の中の変数のため clearTimeout が効かず、
          さらに100ms待つため、マウスを動かした回数ぶんしか進まず、
          端で手を止めると完全に止まっていた。待ちをやめてその場で動かす。
       (3)★端に近いほど速くする。速さは TM_SCROLL_MAX の数字だけで調整できる。
       発動条件(下方向へ100px以上・isMarking)と、上下左右の判定式は1つも変えていない。
       通信・DB・外部通信はいずれも0回。画面の中でスクロール位置を動かすだけ。 */
    var TM_SCROLL_MIN = 3;
    var TM_SCROLL_MAX = 24;
    var element = this.getWrapCenter();
    if (!element) return;
    var mouseX = max(x - startX, 0) - element.offsetLeft;
    var mouseY = max(y - startY, 0) - element.offsetTop;
    var distanceFromTop = mouseY;
    var distanceFromLeft = mouseX;
    var distanceFromRight = element.offsetWidth - mouseX;
    var scrollX = 0;
    var scrollY = 0;
    var speedY = TM_SCROLL_MIN;
    var newY = (y * playerRect.height / 10000) + playerRect.top;
    var windowHeight = window.innerHeight;
    var scrollThreshold = (3 / 4) * windowHeight;
    /* ★上方向の判定を、下方向と同じ「画面上の座標」に揃える。
       元は distanceFromTop(=開始点から何px下か)で見ており、画面のどこに居るかを
       見ていなかったため、上方向は一度も成立していなかった。
       囲っている最中に画面の上へ隠れた開始点まで戻れるようにするためのもので、
       赤枠を上へ広げる話ではない(入口の startY >= y の条件は1文字も変えていない)。 */
    var scrollThresholdTop = (1 / 4) * windowHeight;
    if (newY <= scrollThresholdTop) {
      scrollY = -1;
      var roomT = scrollThresholdTop;
      var ratioT = roomT > 0 ? Math.min(Math.max((scrollThresholdTop - newY) / roomT, 0), 1) : 0;
      speedY = TM_SCROLL_MIN + (TM_SCROLL_MAX - TM_SCROLL_MIN) * ratioT;
    } else if (newY >= scrollThreshold) {
      scrollY = 1;
      var room = windowHeight - scrollThreshold;
      var ratio = room > 0 ? Math.min(Math.max((newY - scrollThreshold) / room, 0), 1) : 0;
      speedY = TM_SCROLL_MIN + (TM_SCROLL_MAX - TM_SCROLL_MIN) * ratio;
    }
    if (distanceFromLeft < TM_SCROLL_MIN) {
      scrollX = -1;
    } else if (distanceFromRight < TM_SCROLL_MIN) {
      scrollX = 1;
    }
    /* ★iPad(iOS Safari)では、-webkit-overflow-scrolling が効いている枠に対して
       scrollBy が無視されることを実機で確認した(枠はスクロール可能量15134あるのに
       scrollBy(0,50) の後も scrollTop が0のまま)。
       scrollTop / scrollLeft を直接書き換える形にすればPC・iPadとも動く。
       動かす量・向き・判定は1つも変えていない。 */
    if (scrollY !== 0) element.scrollTop  = element.scrollTop  + (scrollY * speedY);
    if (scrollX !== 0) element.scrollLeft = element.scrollLeft + (scrollX * TM_SCROLL_MIN);
  }

  goToPage = () => {
    const { goToPage, currentPageIndex } = this.state;
    const pageIndex = parseInt(goToPage, 10) - 1; // Convert to zero-based index
    
    // Only change page if:
    // 1. The page index is valid
    // 2. The page index is different from current page
    if (pageIndex >= 0 &&
        pageIndex < this.props.currentAnimation.animation_pdf_pages.length &&
        pageIndex !== currentPageIndex) {
      this.toggleHeightAnimationPreview();
      this.setState({ currentPageIndex: pageIndex });
    }
  }

  goToPageWithMarker = () => {
    const { markers, currentAnimation, currentMarkerId } = this.props;
    const { currentPageIndex } = this.state;

    if (!markers || !currentAnimation) return;

    const marker = markers.find(m => m.id === currentMarkerId);
    if (!marker || !marker.animation_pdf_page_id) return;

    let pageIndex = currentAnimation.animation_pdf_pages.findIndex(page => page.id === marker.animation_pdf_page_id);

    /* FIX 20260814-cmppage 比較中はコメント側の版のページIDを持つため、表示中の版のページ一覧には
       見つからず（-1）そこで終了していた。見つからない時だけ、コメント側の版の「何枚目か」を求め、
       表示中の版に同じ枚数目があればそのページへ移動する。比較していない時は従来どおり動く。 */
    if (pageIndex < 0) {
      const { animations, animationSelectCurrent, currentAnimationId } = this.props;
      if (animations && animations.length && animationSelectCurrent && currentAnimationId
          && animationSelectCurrent != currentAnimationId) {
        const _cmp = animations.find(_a => _a.id == animationSelectCurrent);
        const _pgs = _cmp && _cmp.animation_pdf_pages;
        if (_pgs && _pgs.length) {
          const _i = _pgs.findIndex(_p => _p.id === marker.animation_pdf_page_id);
          if (_i >= 0 && _i < currentAnimation.animation_pdf_pages.length) pageIndex = _i;
        }
      }
    }

    if (pageIndex >= 0) {
      this.toggleHeightAnimationPreview();
      this.setState({ currentPageIndex: pageIndex, goToPage: pageIndex + 1 }, () => {
        this.props.resetSelectedMarkerId();
      });
    }
  }

  // Zoom controls
  handleZoomIn = () => {
    const { localZoom } = this.state;
    const { onChangeScaleImage } = this.props;

    if (localZoom < 500) {
      const newZoom = Math.min(localZoom + 5, 500);
      this.setState({ localZoom: newZoom });
      if (onChangeScaleImage) {
        onChangeScaleImage(newZoom);
      }
    }
  }

  handleZoomOut = () => {
    const { localZoom } = this.state;
    const { onChangeScaleImage } = this.props;

    if (localZoom > 0) {
      const newZoom = Math.max(localZoom - 5, 0);
      this.setState({ localZoom: newZoom });
      if (onChangeScaleImage) {
        onChangeScaleImage(newZoom);
      }
    }
  }

  handleDownloadPdf = () => {
    const { downloadUrl } = this.props;
    if (downloadUrl) {
      window.open(downloadUrl, '_blank');
    }
  }

  toggle = bool => name => {
    this.setState({ [`shouldShow${name}`]: bool });
  }
  open = this.toggle(true)
  close = this.toggle(false)

  fadeInLoader = () => {
    $('.preloader').fadeIn();
    setInterval(() => {
      $('.preloader').css('opacity', 0.2)
    }, 200);
  }
  startLoading = loadingText => {
    this.fadeInLoader();
    this.setState({ loadingText, isLoading: true });
  }

  endLoading = () => {
    this.setState({ loadingText: null, isLoading: false });
    $('.preloader').fadeOut();
  }

  handleGoToPageKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.goToPageRef.current.blur();
    }
  };

  renderVerticalControlPanel() {
    const { currentPageIndex, goToPage, localZoom } = this.state;
    const { currentAnimation } = this.props;
    const pdfPages = currentAnimation.animation_pdf_pages || [];
    const totalPages = pdfPages.length;
    const { mobile, enabledDownloadPdf } = this.props;

    return (
      <div className={mobile ? 'pdf-horizontal-control-panel' : 'pdf-vertical-control-panel'}>
        {/* Page number input */}
        <div className="pdf-control-item">
          <input
            ref={this.goToPageRef}
            type="text"
            className="pdf-control-input"
            value={goToPage}
            onChange={(e) => {
              const value = e.target.value;
              if (value === '' || (Number(value) > 0 && Number(value) <= totalPages)) {
                this.setState({ goToPage: value });
              }
            }}
            onBlur={this.goToPage}
            onKeyDown={this.handleGoToPageKeyDown}
            min="1"
            max={totalPages}
          />
        </div>

        {/* Total pages */}
        <div className="pdf-control-item">
          <span className="pdf-total-pages">{totalPages}</span>
        </div>

        {/* Previous page button */}
        <button
          className="pdf-control-item"
          onClick={this.goToPreviousPage}
          disabled={currentPageIndex === 0}
          title="前のページ"
        >
          <img src={iconArrowUp} className='pdf-control-icon pdf-icon-transition' />
        </button>

        {/* Next page button */}
        <button
          className="pdf-control-item"
          onClick={this.goToNextPage}
          disabled={currentPageIndex >= totalPages - 1}
          title="次のページ"
        >
          <img src={iconArrowDown} className='pdf-control-icon pdf-icon-transition' />
        </button>

        {/* Zoom in button */}
        <button
          className="pdf-control-item"
          onClick={this.handleZoomIn}
          disabled={localZoom >= 500}
          title="拡大"
        >
          <img src={iconPlus} className='pdf-control-icon pdf-icon-zoom' />
        </button>

        {/* Zoom out button */}
        <button
          className="pdf-control-item"
          onClick={this.handleZoomOut}
          disabled={localZoom <= 0}
          title="縮小"
        >
          <img src={iconMinus} className='pdf-control-icon pdf-icon-zoom' />
        </button>

        {/* Download PDF button */}
        { enabledDownloadPdf &&
          <button
            className="pdf-control-item"
            onClick={this.handleDownloadPdf}
            title="PDFをダウンロード"
          >
            <img src={iconDownload} className='pdf-control-icon pdf-icon-zoom' />
          </button>
        }
      </div>
    );
  }

  isTouchInsidePlayer = (event) => {
    if (!event || !event.touches || !event.touches[0] || !this.currentImageRef.current) return true;
    const imageRect = findDOMNode(this.currentImageRef.current).getBoundingClientRect();
    const touchX = event.touches[0].clientX;
    const touchY = event.touches[0].clientY;
    return (
      touchX >= imageRect.left &&
      touchX <= imageRect.right && 
      touchY >= imageRect.top &&
      touchY <= imageRect.bottom
    );
  }

  render() {
    const { src, downloadUrl, animationMarkerCreationPath, markers, markerCreatable, onClickDownloadButton, mobile,
      onMarkerUpdationCalled, updateMakerShow, currentUserId, role, owner, changeCss, user, scaleImage,
      animationSelectCurrent, currentAnimationId, onMarkerDeletionCalled, reloadMarkers, apiClient,
      currentAnimation, deleteReplyMarker, avatarUrl, project,
      is_project_owner_member, animations
    } = this.props;
    const { currentX, currentY, currentWidth, currentHeight, currentShape, shouldShowForm, markersVisibility,
            isMarking, temp, isShowModalNotCompareVersion, timestamp, currentPageIndex, goToPage, shouldShowGdriveFileDeletedModal
          } = this.state;

    const pdfPages = currentAnimation.animation_pdf_pages || [];
    const totalPages = pdfPages.length;
    const currentPage = pdfPages[currentPageIndex] || null;

    // Filter markers by current page
    let filteredMarkers = markers;
    if (currentAnimation) {
      const currentPageId = currentAnimation.animation_pdf_pages &&
                           currentAnimation.animation_pdf_pages.length > currentPageIndex ?
                           currentAnimation.animation_pdf_pages[currentPageIndex].id : null;

      /* FIX 20260814-cmppage バージョン比較中（メディア側とコメント側で別の版を選んでいる時）に、
         PDFだけコメントカードの番号がメディアに出ず、押しても赤入れの場所へ飛ばない不具合を是正する。
         PDFの赤入れは「どのページの絵に付いたか」をページIDで持つが、このIDは版ごとに別物のため
         （STG実測: 同じページで 版5778=17860 / 版5779=17861）、比較中は必ず不一致となり全て弾かれていた。
         比較中に限り、コメント側の版の「何枚目のページか」で照合する。比較していない時は
         _cmpPages が null となり従来と全く同じ判定になる。枚数が違う版で同じ枚数目が無い時は
         従来どおり出さない（安全側）。通信は1件も増えていない。 */
      const _cmpAnim = (animations && animations.length && animationSelectCurrent
        && currentAnimationId && animationSelectCurrent != currentAnimationId)
        ? animations.find(_a => _a.id == animationSelectCurrent) : null;
      const _cmpPages = (_cmpAnim && _cmpAnim.animation_pdf_pages) || null;

      filteredMarkers = markers.filter(marker => {
        // If marker does not have animation_pdf_page_id (old markers) or matches current page
        if (!marker.animation_pdf_page_id || marker.animation_pdf_page_id === currentPageId) return true;
        if (_cmpPages && _cmpPages.length) {
          const _i = _cmpPages.findIndex(_p => _p.id === marker.animation_pdf_page_id);
          if (_i >= 0 && _i === currentPageIndex) return true;
        }
        return false;
      });
    }
    const gdriveDeletedModal = (
      <React.Fragment>
        <GdriveFileDeletedModal
          isOpen={shouldShowGdriveFileDeletedModal}
          onClickClose={this.close.bind(this, 'GdriveFileDeletedModal')}
          apiClient={apiClient}
          currentAnimationId={currentAnimationId}
          currentAnimation={currentAnimation}
          onStart={this.startLoading.bind(this, 'Now Processing...')}
          endLoading={this.endLoading}
          type='image'
          project={project}
          applyAllGdrive={this.props.applyAllGdrive}
          canUseApplyAll={this.props.canUseApplyAll}
          defaultGdriveLogic={this.props.defaultGdriveLogic}
        />
        <NavLink href="#!" className='hidden d-none' id="gdriveFileDeletedModal" onClick={this.open.bind(this, 'GdriveFileDeletedModal')}>
        </NavLink>
      </React.Fragment>
    )
    
    return (
      currentAnimation.need_conversion ? (
        <div
          id="wrap-center"
          style={{minHeight:"94%"}}
          className={`wrap-animation-preview ${mobile ? 'wrap-animation-preview-image-for-mobile' : ''} ${getStyleOfSize(scaleImage,"wrap")}`}>
          <div
            className="animation-preview"
            id="animation-preview"
            style={{width:`${scaleImage}%`}}
            ref={(ref) => (this.wrap = ref)}
          >
            <div
              className="animation-image"
              id="animation-image"
            >
              <div className='project__image' id="project__image">
                <img
                  crossOrigin="anonymous" onLoad={this.onImageLoad} src={imgConvertingPdfThumbnail}
                  alt='logo' id="img"
                />
              </div>
            </div>
          </div>
          {gdriveDeletedModal}
        </div>
      ) : (
        <div className='d-flex flex-gap-5'>
          <div
            id="wrap-center"
            style={{minHeight:"94%", width:`100%`}}
            className={`wrap-animation-preview ${mobile ? 'wrap-animation-preview-image-for-mobile' : ''} ${getStyleOfSize(scaleImage,"wrap")}`}>
            <div
              className={`animation-preview ${getStyleOfSize(scaleImage)}` }
              id="animation-preview"
              style={{width:`${scaleImage}%`}}
              ref={(ref) => (this.wrap = ref)}
            >
              <div
                className={classnames('animation-image', { marking: isMarking })}
                id="animation-image"
              >
                {currentPage ? (
                  <div 
                    className='pdf-preview-container' 
                    style={{position: 'relative', width: '100%'}} 
                    ref={this.pdfContainerRef}
                    id="pdf-container"
                  >
                    <img
                      key={`pdf-page-${currentPageIndex}`}
                      id={`pdf-page-${currentPageIndex}`}
                      src={`${currentPage.file_object.url}?v=${timestamp}`}
                      alt={`PDF page ${currentPageIndex + 1}`}
                      className="current-pdf-page"
                      style={{
                        width: '100%', 
                        height: '100%', 
                        display: 'block', 
                        margin: 0, 
                        padding: 0,
                        objectFit: 'contain',
                        maxWidth: '100%',
                      }}
                      ref={this.currentImageRef}
                      onLoad={(e) => this.onPdfPageLoad(e, currentPageIndex)}
                      /* FIX 20260811-pdfretry iPadで画像の取得に失敗しても何もしていなかったため、
                         壊れた画像がそのまま残り続けていた(crossOrigin指定はペンツールがcanvasへ
                         描くために必要なので外さない)。失敗した時だけ、同じ画像を1回だけ取り直す。
                         取り直しは1枚につき1回限りとし、無限に繰り返さない。成功時は何も変わらない。 */
                      onError={(e) => {
                        const __img = e.currentTarget;
                        if (__img.dataset.tmRetried) return;
                        __img.dataset.tmRetried = '1';
                        const __base = String(__img.src).split('?')[0];
                        setTimeout(() => { __img.src = `${__base}?v=${new Date().getTime()}`; }, 300);
                      }}
                      crossOrigin="anonymous"
                    />
                  </div>
                ) : (
                  <div></div>
                )}

                <canvas
                    id="canvas"
                    ref={(ref) => (this.canvas = ref)}
                    width={`${this.state.canvasWidth}px`}
                    height={`${this.state.canvasHeight}px`}
                    style={Object.assign({}, styles.canvas, {zIndex: this.state.zIndexSvg})}
                  ></canvas>

                  <div
                    ref={(ref) => (this.drawSvg = ref)}
                    className="draw-svg"
                    style={{
                      zIndex: this.state.zIndexSvg,
                      touchAction: (this.props.isCommentMode) ? 'none' : 'auto',
                    }}
                    onMouseDown={(event) => this.onMouseDown(event, false)}
                    onMouseMove={(event) => this.onMouseMove(event, false)}
                    onMouseUp={() => this.onMouseUp()}
                    onMouseLeave={() => this.onMouseUp()}
                    onTouchStart={(event) => this.onMouseDown(event, true)}
                    onTouchEnd={() => this.onMouseUp()}
                    onTouchMove={(event) => this.onMouseMove(event, true)}
                  >
                    <svg
                      preserveAspectRatio="none"
                      viewBox={`0 0 ${this.state.canvasWidth} ${this.state.canvasHeight}`}
                      className={this.state.isDel ? 'cursor_eraser': `cursor_pencil_${this.state.settingDraw.color}`}
                      width={`${this.state.canvasWidth}px`}
                      height={`${this.state.canvasHeight}px`}
                      ref={(ref) => (this.svg = ref)}
                      style={Object.assign(
                        {},
                        styles.canvas,
                        { zIndex: this.state.zIndexSvg },
                      )}
                    >
                      {this.state.listItemSvg.map((item, i) => (
                        <PolyLineSvg
                          id={item.id}
                          points={item.points}
                          color={item.color}
                          lineWidth={item.lineWidth}
                          onItemMouseOver={(event) => this.onItemMouseOver(event)}
                          onItemMouseLeave={(event) => this.onItemMouseLeave(event)}
                          onDelete={(event) => this.onDelete(event)}
                        />
                      ))}
                    </svg>
                  </div>
                {
                  !canUserNotPermission(role) && markerCreatable || !gon.is_login || this.props.isCommentMode ? ( <div
                    className={changeCss ? 'overlay-fix' : 'overlay akapon'}
                    onMouseDown={(event) => {
                      if (this._touchHandled) return;
                      event.stopPropagation();
                      event.preventDefault();
                      const now = Date.now();
                      const delta = now - this._lastTapTime;
                      this._lastTapTime = now;
                      if (delta < this._DOUBLE_TAP_MS && delta > 0) {
                        this._lastTapTime = 0;
                        if (!this.props.isCommentMode) {
                          this._showCommentMode();
                          this._showModeToast('コメントモードに切り替わりました');
                        }
                        return;
                      }
                      if (!this.props.isCommentMode) {
                        this._showTapHint();
                        return;
                      }
                      this.disableMmount('none');
                      const [x, y] = this.mouseRelativeXY(event);
                      this.startMark({ x, y });
                    }}
                    onTouchStart={(event) => {
                      this._touchHandled = true;
                      setTimeout(() => { this._touchHandled = false; }, 500);
                      event.stopPropagation();
                      event.preventDefault();
                      const now = Date.now();
                      const delta = now - this._lastTapTime;
                      this._lastTapTime = now;
                      if (delta < this._DOUBLE_TAP_MS && delta > 0) {
                        this._lastTapTime = 0;
                        if (!this.props.isCommentMode) {
                          this._showCommentMode();
                          this._showModeToast('コメントモードに切り替わりました');
                        }
                        return;
                      }
                      if (!this.props.isCommentMode) {
                        this._showTapHint();
                        return;
                      }
                      /* FIX 20260812-tapver iPadで画像を指でスクロールしただけで
                         コメントツールの版がメディア側へ戻る不具合を是正する。タッチ開始時に
                         無条件で setOption(比較解除)を呼んでいたため、スクロール・2度押し・
                         閲覧モードでも発火していた。実際に赤入れを始める直前へ移し、
                         マウス操作側と同じ条件に揃える。処理内容は変えていない。 */
                      this.setOption();
                      const [x, y] = this.touchRelativeXY(event);
                      this.startMark({ x, y });
                    }}
                    onMouseMove={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      const [x, y] = this.mouseRelativeXY(event);
                      this.moveMark({ x, y });
                      this.scrollImage(this.currentImageRef.current, {x, y});
                    }}
                    onTouchMove={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      /* FIX 20260831-touchscroll 指の操作を、マウスと同じ作りに揃える。
                         (1)指がメディアの外へ出た瞬間に endMark していたため、下まで囲おうとすると
                            その場で囲いが確定してコメントBOXが開き、続きを囲えなかった。
                            マウス側は外へ出ても囲いが続く作りで、PCでは従来から下まで囲えている。
                            指を離せば onTouchEnd / onTouchCancel で必ず確定するため、囲いっぱなしにはならない。
                         (2)scrollImage がマウス側からしか呼ばれておらず、指では自動スクロールが
                            一度も動いていなかった。マウス側と同じ位置で呼ぶ。
                         moveMark・startMark・endMark・座標の変換はいずれも1文字も変更していない。
                         動画とYouTube(AnimationPlayer / ShowEmbedVideos)は別ファイル・別実装のため無関係。 */
                      const [x, y] = this.touchRelativeXY(event);
                      this.moveMark({ x, y });
                      this.scrollImage(this.currentImageRef.current, {x, y});
                    }}
                    onMouseUp={this.endMark}
                    onTouchEnd={this.endMark}
                    onTouchCancel={this.endMark}
                    onClick={this.setOption}
                  >
                  </div>) : ( <div />)
                }
                {
                  isMarking && <MarkShape x={currentX} y={currentY} width={currentWidth} height={currentHeight} shape={currentShape} />
                }
                <AnimationMarkersInPlayer
                  markers={filteredMarkers} visibility={markersVisibility} order={11}
                  onMarkerUpdationCalled={onMarkerUpdationCalled} 
                  image={this.currentImageRef.current}
                  updateMakerShow={updateMakerShow}
                />
                {
                  shouldShowForm && (
                    <AnimationMarkerForm
                      x={currentX} y={currentY} width={currentWidth} height={currentHeight}
                      shape={currentShape} onSubmit={this.onSubmitMarkerForm}
                      onClickClose={this.onCloseMarkerForm} order={12} mobile={mobile}
                      shouldShowForm={shouldShowForm} currentUserId={currentUserId} role={role} owner={owner} user={user}
                      scaleImage={scaleImage}
                      ref={(ref) => (this.makerForm = ref)}
                      is_embed_video={false}
                      is_show_draw_component={true}
                    />
                  )
                }
              </div>
            </div>
            <CommentDetail
              selectedMarker={this.props.selectedMarker}
              updateSelectedMarker={this.props.updateSelectedMarker}
              onMarkerUpdationCalled={onMarkerUpdationCalled}
              currentUserId={currentUserId}
              owner={owner}
              role={role}
              animationSelectCurrent={animationSelectCurrent}
              currentAnimationId={currentAnimationId}
              onMarkerDeletionCalled={onMarkerDeletionCalled}
              reloadMarkers={reloadMarkers}
              apiClient={apiClient}
              markers={markers}
              deleteReplyMarker={deleteReplyMarker}
              avatarUrl={avatarUrl}
              shouldShowForm={shouldShowForm}
              is_project_owner_member={is_project_owner_member}
            />
            <div ref={nodeModalVersion => { this.nodeModalVersion = nodeModalVersion }}>
              <Modal isOpen={isShowModalNotCompareVersion}
                  className="animation-uploader-modal modal-dialog-centered modal-not-compare-version "
                  size="md" >
                <ModalBody>
                  <div className='text-center text-black'>
                    <div className='font-size-of-modal-not-compare font-weight-bold text-black text-center'>
                      <span>メディア画面とコメントツールの </span>
                      <span>バージョンが異なる為、赤入れできません。</span>
                    </div>
                    <Button className="btn btn-danger my-2 button-set-current-animation" onClick={this.fetchCurrentAnimation}>
                      表示中のメディア画面を赤入れする
                    </Button>
                    <span class="text-of-current-title">
                      ※クリックするとコメントツールのバージョンが{currentAnimation && currentAnimation.final ? '最終稿' : currentAnimation && currentAnimation.title}に変わります。
                    </span>
                  </div>
                </ModalBody>
              </Modal>
            </div>
            {gdriveDeletedModal}
          </div>
          {/* Vertical Control Panel */}
          {this.renderVerticalControlPanel()}
        </div>
      )
    )
  }
}
